import { ReactNode } from 'react';
import { AppText } from 'components/atoms/CommonAppComponents';
import { Container, Header } from './WeeklyScheduleCardBase.styled';

export type WeeklyScheduleCardBaseProps = {
    dayLabel: string;
    date?: string;
    children: ReactNode;
    accessibilityLabel?: string;
};

export const WeeklyScheduleCardBase = ({
    dayLabel,
    date,
    children,
    accessibilityLabel,
}: WeeklyScheduleCardBaseProps) => {
    const dateInfo = date ? (
        <AppText margin={0} textType="Caption">
            {date}
        </AppText>
    ) : null;

    return (
        <Container aria-label={accessibilityLabel}>
            <Header>
                <AppText margin={0} textType="BodyMediumSemiBold">
                    {dayLabel}
                </AppText>
                {dateInfo}
            </Header>
            {children}
        </Container>
    );
};
